import { useRoutes } from 'lib/hooks'
import { useHomeStore } from 'context/HomeStore'
import { Grid, IconButton, Typography } from '@material-ui/core'
import { Pagination } from 'asterX-UI/Pagination'
import { DOCUMENT_PATH } from 'routes/constants.routes'
import StandardTable from 'asterX-UI/Table/StandardTable'
import { ChevronRight } from '@material-ui/icons'
import { formatDateTime } from 'lib/utils'
import { useTableStyles } from './table.styles'

export const Table = () => {
  const classes = useTableStyles()
  const router = useRoutes()
  const {
    homeStore: { lists, pagination },
    homeStoreFunc: { handlePaginationChange }
  } = useHomeStore()

  const columns = ['Номер контракта', 'ФИО клиента', 'ИИН клиента', 'Дата создания', '']

  const rows = lists
    ? lists?.map(item => {
        const { contractId, clientFullName, clientIin, createdDate } = item
        return [
          contractId || '-',
          <Typography className={classes.title}>{clientFullName || '-'}</Typography>,
          <Typography className={classes.title}>{clientIin || '-'}</Typography>,
          <Typography className={classes.title}>{formatDateTime(createdDate)}</Typography>,
          <IconButton>{<ChevronRight />}</IconButton>
        ]
      })
    : []

  return (
    <Grid item container>
      <Grid item container className={classes.table}>
        <Grid item container>
          <StandardTable
            tableData={{
              columns,
              rows
            }}
            onRowClick={row => {
              router.goTo(`${DOCUMENT_PATH}/${row[0]}`)
            }}
            tableStyles={{
              borderRadius: 12,
              boxShadow: 'none'
            }}
          />
        </Grid>

        <Grid item container style={{ padding: '12px 24px' }}>
          <Pagination
            className={classes.pagination}
            count={Math.ceil(pagination.count)}
            page={pagination.offset ? pagination.offset : 1}
            onChange={handlePaginationChange}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}
